import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { User } from 'src/app/user/models';
import { DateTimeService } from '../../datetime/datetime.service';
import { ChangeLogAction, ChangeLogItem } from '../models/change-log-item';
import { DxDataGridModule } from 'devextreme-angular';
import { BizDataGridDirective } from '../../grid/biz-grid.directive';
import { DxoPagingModule, DxiColumnModule, DxoLookupModule } from 'devextreme-angular/ui/nested';
import { DxTemplateModule } from 'devextreme-angular/core';
import { ChangeLogViewerDetailsComponent } from '../change-log-viewer-details/change-log-viewer-details.component';

interface ChangeLogActionLookup {
  id: ChangeLogAction;
  name: string;
}

@Component({
    selector: 'app-change-log-viewer',
    templateUrl: './change-log-viewer.component.html',
    styleUrls: ['./change-log-viewer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxDataGridModule, BizDataGridDirective, DxoPagingModule, DxiColumnModule, DxoLookupModule, DxTemplateModule, ChangeLogViewerDetailsComponent]
})
export class ChangeLogViewerComponent {
  @Input() items: ChangeLogItem[] = [];
  @Input() users: User[] = [];

  logActions: ChangeLogActionLookup[] = [
    { id: ChangeLogAction.Insert, name: 'Create' },
    { id: ChangeLogAction.Update, name: 'Edit' },
    { id: ChangeLogAction.Delete, name: 'Delete' },
  ];

  constructor(
    public dateTimeService: DateTimeService) {
  }
}
